if (!window.CandidateLink) window.CandidateLink = {};

(function () {
  const ajax = new XMLHttpRequest();
  ajax.open('GET', `${window.location.origin}/api/system/v1/countries_states.json`);

  ajax.onreadystatechange = function () {
    if (ajax.readyState !== 4) return;

    try {
      window.CandidateLink.countries = JSON.parse(ajax.responseText);
      // eslint-disable-next-line no-unused-vars
    } catch (exception) {
      // eslint-disable-next-line no-alert
      alert('Data is not loaded properly, please try loading the page again.');
    }
    try {
      reloadStates();
      preselectState();
    } catch (_exception) {
      // Doesn't have states and countries select, doing nothing
    }
  };
  ajax.send();

  const selectCountry = document.getElementById(
    'application_candidate_attributes_address_attributes_country_id'
  );
  const selectState = document.getElementById(
    'application_candidate_attributes_address_attributes_state_id'
  );

  if (!selectCountry || !selectState) return;

  function reloadStates() {
    const val = parseInt(selectCountry.value, 10);
    let country = null;

    for (var i in window.CandidateLink.countries) {
      if (window.CandidateLink.countries[i].id === val) {
        country = window.CandidateLink.countries[i];
        break;
      }
    }

    selectState.options.length = 0;

    selectState.add(new Option('Please choose...', ''), null);

    if (!country) return;

    let otherState;

    Object.values(country.states).forEach((state) => {
      if (state.name === 'Other') {
        otherState = state;
        return;
      }
      const option = new Option(state.name, state.id);
      selectState.add(option, null);
    });

    if (otherState) {
      const option = new Option(otherState.name, otherState.id);
      selectState.add(option, null);
    }
  }

  var preselectState = function () {
    const { initialId } = selectState.dataset;
    if (!initialId) return;

    selectState.value = initialId;
    if (selectState.value === String(initialId)) return;

    Array.from(selectState.options).forEach((option) => {
      option.selected = String(option.value) === String(initialId);
    });
  };

  selectCountry.addEventListener('change', reloadStates, true);
})();
